import React from 'react';
import ProjectList from '../projects/ProjectList';
import NewProject from '../projects/NewProject';

const Sidebar = () => {
    return ( 
        <aside>
            <h1>MERN<span> Tasks</span></h1>
            <NewProject />
            <div className="proyectos">
                <h2>Your Projects</h2>
                <ProjectList />
            </div>
        </aside>
     );
}
 
export default Sidebar;